// Theme (light/dark) + reading preferences (font size, line height), persisted.

type Theme = "light" | "dark";

const THEME_KEY = "book.theme";
const SIZE_KEY = "book.read.size";
const LEAD_KEY = "book.read.leading";

export function initTheme(): Theme {
  const saved = localStorage.getItem(THEME_KEY) as Theme | null;
  const theme = saved ?? (matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
  applyTheme(theme);
  return theme;
}

export function applyTheme(theme: Theme) {
  document.documentElement.setAttribute("data-theme", theme);
  localStorage.setItem(THEME_KEY, theme);
}

export function toggleTheme(): Theme {
  const next: Theme = document.documentElement.getAttribute("data-theme") === "dark" ? "light" : "dark";
  applyTheme(next);
  return next;
}

export function currentTheme(): Theme {
  return (document.documentElement.getAttribute("data-theme") as Theme) ?? "light";
}

// Reading prefs ----------------------------------------------------------------
export function getReadSize(): number {
  return Number(localStorage.getItem(SIZE_KEY) ?? 19);
}
export function getReadLeading(): number {
  return Number(localStorage.getItem(LEAD_KEY) ?? 1.62);
}
export function applyReadPrefs(size = getReadSize(), leading = getReadLeading()) {
  document.documentElement.style.setProperty("--read-size", `${size}px`);
  document.documentElement.style.setProperty("--read-leading", String(leading));
  localStorage.setItem(SIZE_KEY, String(size));
  localStorage.setItem(LEAD_KEY, String(leading));
}
